import InputField from '../Forms/Input/InputField';
import Checkbox from '../Forms/Input/Checkbox';
import { EmailConfigurationForm as FormType } from '../../types/email/EmailTypes';
import SelectField from '../Forms/Input/SelectField';
import SecretField from '../Forms/Input/SecretField';

interface Props {
  form: FormType;
  testEmail: string;
  errors: Record<string, string>;
  onChange: (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => void;
  onToggleField: (field: 'authEnabled' | 'tlsEnabled' | 'active') => void;
  onTestEmailChange: (email: string) => void;
  onSave: () => void;
  onSendTest: () => void;
}

const EmailConfigurationForm = ({
  form,
  testEmail,
  errors,
  onChange,
  onToggleField,
  onTestEmailChange,
  onSave,
  onSendTest,
}: Props) => {
  const SMTP_PROVIDERS = [
    {
      value: 'GMAIL',
      label: 'Gmail',
    },
    {
      value: 'OUTLOOK',
      label: 'Outlook',
    },
    {
      value: 'SMTP_CUSTOM',
      label: 'SMTP Personalizado',
    },
  ];

  return (
    <div className="space-y-8 p-4 px-4 py-5">
      <div>
        <p className="text-gray-500 dark:text-gray-400 text-sm">
          Configure el servidor SMTP que usara el sistema para enviar correos
          electronicos.
        </p>
      </div>

      {errors.general && <p className="text-sm text-red">{errors.general}</p>}

      <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
        <SelectField
          label="Proveedor"
          name="provider"
          value={form.provider}
          onChange={onChange}
          options={SMTP_PROVIDERS}
          placeholder="Seleccione un proveedor"
          iconKey="company"
          error={errors.provider}
          required
        />

        <InputField
          label="Host SMTP"
          name="smtpHost"
          value={form.smtpHost}
          onChange={onChange}
          disabled={form.provider !== 'SMTP_CUSTOM'}
          placeholder="smtp.dominio.com"
          iconKey="server"
          error={errors.smtpHost}
          type="text"
          required
        />

        <InputField
          label="Puerto SMTP"
          name="smtpPort"
          value={form.smtpPort ?? ''}
          onChange={onChange}
          disabled={form.provider !== 'SMTP_CUSTOM'}
          placeholder="587"
          iconKey="port"
          error={errors.smtpPort}
          type="number"
          required
        />

        <InputField
          label="Usuario"
          name="username"
          value={form.username}
          onChange={onChange}
          placeholder="usuario@dominio.com"
          iconKey="user"
          error={errors.username}
          type="text"
          required
        />

        <SecretField
          label="Contraseña SMTP"
          name="password"
          value={form.password}
          placeholder="Contraseña o App Password"
          iconKey="key"
          error={errors.password}
          required
          onChange={(value) =>
            onChange({
              target: {
                name: 'password',
                value,
              },
            } as React.ChangeEvent<HTMLInputElement>)
          }
        />

        <InputField
          label="Nombre del remitente"
          name="fromName"
          value={form.fromName}
          onChange={onChange}
          placeholder="Codenova POS"
          iconKey="company"
          error={errors.fromName}
          type="text"
          required
        />

        <InputField
          label="Correo remitente"
          name="fromEmail"
          value={form.fromEmail}
          onChange={onChange}
          placeholder="notificaciones@dominio.com"
          iconKey="email"
          error={errors.fromEmail}
          type="email"
          required
        />
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <Checkbox
          label="Requiere autenticacion"
          checked={form.authEnabled}
          onChange={() => onToggleField('authEnabled')}
        />
        <Checkbox
          label="Usar TLS"
          checked={form.tlsEnabled}
          onChange={() => onToggleField('tlsEnabled')}
        />
        <Checkbox
          label="Configuracion activa"
          checked={form.active}
          onChange={() => onToggleField('active')}
        />
      </div>

      <div className="rounded border border-stroke p-4 dark:border-form-strokedark">
        <div className="grid grid-cols-1 items-end gap-4 lg:grid-cols-[1fr_auto]">
          <InputField
            label="Enviar prueba a"
            name="testEmail"
            value={testEmail}
            onChange={(event) => onTestEmailChange(event.target.value)}
            placeholder="cliente@correo.com"
            iconKey="email"
            error={errors.testEmail}
            type="email"
          />

          <button
            type="button"
            onClick={onSendTest}
            className="mb-4 rounded bg-secondary px-6 py-3 font-medium text-white hover:bg-opacity-90"
          >
            Enviar Prueba
          </button>
        </div>
      </div>

      <div className="mt-6 flex justify-end">
        <button
          type="button"
          onClick={onSave}
          className="rounded bg-primary px-6 py-2.5 font-medium text-white hover:bg-opacity-90"
        >
          Guardar Configuracion
        </button>
      </div>
    </div>
  );
};

export default EmailConfigurationForm;
